import { resource, RequestConfig } from '../helper/resource';

/**
 * 购买产品-产品查询
 */
export function zgServer_bookStatusUsingPOST(req: void, config?: RequestConfig): Promise<ZgServer.TtdResponse> {
  return resource.post('/ttd/bookStatus', req, config);
}

/**
 * 购买产品-创建订单
 */
export function zgServer_createOrderUsingPOST(req: any, config?: RequestConfig): Promise<ZgServer.TtdResponse> {
  return resource.post('/ttd/createOrder', req, config);
}

/**
 * 获取文件的URL
 */
export function zgServer_getFileUrlUsingPOST(req: void, config?: RequestConfig): Promise<ZgServer.TtdResponse> {
  return resource.post('/ttd/file/get', req, config);
}

/**
 * 购买产品-productSerialNo字段获取
 */
export function zgServer_getProdSeNoUsingPOST(req: any, config?: RequestConfig): Promise<ZgServer.TtdResponse> {
  return resource.post('/ttd/getProdSeNo', req, config);
}

/**
 * 签署经办人风险书
 */
export function zgServer_managerSignUsingPOST(req: any, config?: RequestConfig): Promise<ZgServer.TtdResponse> {
  return resource.post('/ttd/managerSign', req, config);
}

/**
 * 创建经办人
 */
export function zgServer_createNatHandlerUsingPOST(req: any, config?: RequestConfig): Promise<ZgServer.TtdResponse> {
  return resource.post('/ttd/natHandler', req, config);
}

/**
 * 购买产品-添加投资者
 */
export function zgServer_natInvestorUsingPOST(req: any, config?: RequestConfig): Promise<ZgServer.TtdResponse> {
  return resource.post('/ttd/natInvestor', req, config);
}

/**
 * 获取订单签署文件的原文件及待文件或签署后的文件
 */
export function zgServer_getRelationFilesUsingPOST(req: void, config?: RequestConfig): Promise<ZgServer.TtdResponse> {
  return resource.post('/ttd/relation/files', req, config);
}

/**
 * 创建产品风险揭示书副本
 */
export function zgServer_createRevelBookUsingPOST(req: any, config?: RequestConfig): Promise<ZgServer.TtdResponse> {
  return resource.post('/ttd/revelbook/copies', req, config);
}

/**
 * 查询投资者的信息
 */
export function zgServer_userListUsingPOST(req: void, config?: RequestConfig): Promise<ZgServer.TtdResponse> {
  return resource.post('/ttd/userList', req, config);
}
